import { FormOption } from '../../../../../../../../types/Form';
import { FlowsQuestion } from '../../../../../types/FlowsTypes';
import { KVPercentage } from '../index-percentage/SingleIndexPercentageInput';

const useAvailableOptions = (
  question: FlowsQuestion,
  options: FormOption[],
  chosenValues: KVPercentage[],
): FormOption[] => {
  const availableOptions = options.filter(
    ({ value }) => !chosenValues.map(({ key }) => key).includes(value),
  );

  return availableOptions;
};

export default useAvailableOptions;
